
import { defineComponent } from 'vue';
import VideoDatabaseEntry from '@/model/VideoDatabaseEntry';
import db from '@/services/VideoDatabase';
import miniLessonManager from '@/services/MiniLessonManager';
import keyframeOptions from '@/data/keyframeOptions.json';

export default defineComponent({
  name: 'LessonCard',
  props: {
    motion: {
      type: Object,
    },
    canCreateLesson: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    lessons() {
      if (!this.motion) return [];
      const motion = this.motion as VideoDatabaseEntry;
      const lessons = miniLessonManager.getLessons(motion);
      return lessons ?? [];
    },
    keyframeOptions() {
      if (!this.motion) return [];
      const motion = this.motion as VideoDatabaseEntry;
      return keyframeOptions.filter((option) => option.clipName === motion.clipName);
    },
  },
  emits: ['lesson-selected', 'create-lesson-selected', 'closed', 'keyframeselectortool-selected'],
});
